import { KEY_ESCAPE } from 'keycode-js';
import { throttle } from 'throttle-debounce';
import $ from '../lib/jquery';

import { Component } from '../core/component';
import { wait } from '../helpers';

export class MobileNavigation extends Component {
    selector = '.js-mobile-nav';

    $menuTrigger = null;

    $menuOverlay = null;

    $searchTrigger = null;

    $searchOverlay = null;

    isMenuOpen = false;

    isSearchOpen = false;

    init() {
        this.$menuTrigger = this.$elements.find('.js-mobile-menu-trigger');
        this.$menuOverlay = this.$elements.find('.js-mobile-menu-overlay');
        this.$searchTrigger = this.$elements.find('.js-mobile-search-trigger');
        this.$searchOverlay = this.$elements.find('.js-mobile-search-overlay');

        this.$menuTrigger.on('click', this.toggleMenu);

        this.$searchTrigger.on('click', this.toggleSearch);

        this.$elements.on('click', (evt) => {
            evt.stopPropagation();
        });

        $(document).on('click', () => {
            this.closeSearch();
        });


        $(document).on('keyup', (evt) => {
            if (evt.keyCode === KEY_ESCAPE) {
                this.closeMenu();
                this.closeSearch();
            }
        });

        $(window).on('scroll', throttle(100, () => this.closeSearch()));
    }

    toggleMenu = () => (this.isMenuOpen ? this.closeMenu() : this.openMenu());

    toggleSearch = () => (this.isSearchOpen ? this.closeSearch() : this.openSearch());

    openMenu = async () => {
        if (this.isSearchOpen) this.closeSearch();
        if (this.isMenuOpen) return;
        this.$menuTrigger.addClass('is-active');
        this.$menuTrigger.attr('aria-label', this.$menuTrigger.data('close-text'));
        this.$menuTrigger.attr('aria-expanded', true);
        this.$menuOverlay.removeClass('is-hidden');
        await wait(10);
        this.$menuOverlay.addClass('is-open');
        await wait(260);
        this.isMenuOpen = true;
    };

    closeMenu = async () => {
        if (!this.isMenuOpen) return;
        this.$menuTrigger.removeClass('is-active');
        this.$menuTrigger.attr('aria-label', this.$menuTrigger.data('open-text'));
        this.$menuTrigger.attr('aria-expanded', false);
        this.$menuOverlay.removeClass('is-open');
        await wait(260);
        this.$menuOverlay.addClass('is-hidden');
        this.isMenuOpen = false;
    };

    openSearch = async () => {
        if (this.isMenuOpen) this.closeMenu();
        if (this.isSearchOpen) return;
        this.$searchTrigger.attr('aria-label', this.$searchTrigger.data('close-text'));
        this.$searchTrigger.attr('aria-expanded', true);
        this.$searchOverlay.removeClass('is-hidden');
        await wait(10);
        this.$searchOverlay.addClass('is-open');
        this.isSearchOpen = true;
    };

    closeSearch = async () => {
        if (!this.isSearchOpen) return;
        this.$searchTrigger.attr('aria-label', this.$searchTrigger.data('open-text'));
        this.$searchTrigger.attr('aria-expanded', false);
        this.$searchOverlay.removeClass('is-open');
        await wait(260);
        this.$searchOverlay.addClass('is-hidden');
        await wait(260);
        this.isSearchOpen = false;
    };
}



// WEBPACK FOOTER //
// ./assets/js/components/MobileNavigation.js